import { FC } from 'react';
import { IndicatorIndexedPath } from '../indicator-config-form.utils';
import { TradingFormField } from '../../trading-form-field';

type ZigZagFieldsProps = {
  path: IndicatorIndexedPath;
};

export const ZigZagFields: FC<ZigZagFieldsProps> = ({ path }) => {
  return (
    <>
      <TradingFormField
        type="numeric"
        name={`${path}.deviationThreshold`}
        label="Deviation Threshold"
      />
      <TradingFormField type="numeric" name={`${path}.depth`} label="Depth" />
    </>
  );
};
